module.exports = __webpack_public_path__ + "img/icon-height.da9641cf.png";